// extracted by mini-css-extract-plugin
export default {"root":"ResultsDisplay_root__7PAGn"};